export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8707.036ad5f4.jpg";